<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i>&nbsp; Know Your Client</h5>
      </div>
<div id="mainContent" class="container">
    <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-5 col-form-label">Enter Your Client Name:</label>
          <div class="col-sm-6">
            <select class="form-control form-control-sm mt-1"
              [(ngModel)]="selectClientName"
              (change)="onClientSelect()">
              <option value="">Select Client Name</option>
              <option *ngFor="let clientName of clientList" [ngValue]="clientName">
                {{ clientName.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-1"></div>
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="getClientReport()"
        >
          Get Details
        </button>
    </div>
    </div>
     </div>
    </div>

    <div class="container" id="mainContent">
      <div class="mt-5" *ngIf="clientDetail">
        <div class="row justify-content-center text-center pt-4">
          <span class="bg-theme-title"
            >P G BHAGWAT LLP, Chartered Accountants
          </span>
        </div>
        <div class="row justify-content-center text-center ">
          <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
        </div>
           
        <div class="row mt-4">
            <div class="col-md-12">
              <span class="bg-theme-title">Details of {{ selectClientName.name }} are as follows : </span>
            </div>
          </div>

          <div class="row mt-2" *ngIf="clientDetail">
            <div class="col-md-10">
              <table class="table table-bordered table-striped table-sm">
                <tbody>
                  <tr>
                    <th>Legal Status:</th>
                    <td *ngIf="clientDetail.legalStatus != null">
                      {{ clientDetail.legalStatus.name }}
                    </td>
                    <td *ngIf="clientDetail.legalStatus == null"></td>
                  </tr>
                  <tr>
                    <th>Ediary Status:</th>
                    <td *ngIf="clientDetail.ediaryStatus != null">
                      {{ clientDetail.ediaryStatus.name }}
                    </td>
                    <td *ngIf="clientDetail.ediaryStatus == null"></td>
                  </tr>
                  <tr>
                    <th>Distance(Round Trip) In Kms:</th>
                    <td *ngIf="clientDetail.clientLocations != null">
                      <span
                        *ngFor="let data of clientDetail.clientLocations"
                      >
                        {{ data.distance }} 
                        </span>
                    </td>
                    <td *ngIf="clientDetail.clientLocations == null"></td>
                  </tr>
                  <tr>
                    <th>Chargable To Client:</th>
                    <td *ngIf="clientDetail.chargeableToClient != null">
                      {{ clientDetail.chargeableToClient=='true'?'Yes':'No' }}
                    </td>
                    <td *ngIf="clientDetail.chargeableToClient == null"></td>
                  </tr>
                  <tr>
                    <th>Branch Name:</th>
                    <td *ngIf="clientDetail.branch != null">
                      {{ clientDetail.branch.name }}
                    </td>
                    <td *ngIf="clientDetail.branch == null"></td>
                  </tr>
                  <tr>
                    <th>Address:</th>
                    <td>{{ clientDetail.address }}</td>
                  </tr>
                  <tr>
                    <th>PAN Number:</th>
                    <td *ngIf="clientDetail.pan != null">
                      {{ clientDetail.pan }}
                    </td>
                    <td *ngIf="clientDetail.pan == null"></td>
                  </tr>
                  <tr>
                    <th>Client Email:</th>
                    <td *ngIf="clientDetail.email != null">
                      {{ clientDetail.email }}
                    </td>
                    <td *ngIf="clientDetail.email == null"></td>
                  </tr>
                  <tr>
                    <th>Location:</th>
                    <td *ngIf="clientDetail.city != null">
                      {{ clientDetail.city.name }}
                    </td>
                    <td *ngIf="clientDetail.city == null"></td>
                  </tr>
                  <tr>
                    <th>Partner Assigned:</th>
                    <td *ngIf="clientDetail.partners.length>0">
                        {{ clientDetail.partners[clientDetail.partners.length-1].name }}
                    </td>
                    <td *ngIf="clientDetail.partners.length==0"></td>
                  </tr>
                  <tr>
                    <th>Sector:</th>
                    <td *ngIf="clientDetail.sector != null">
                      {{ clientDetail.sector.name }}
                    </td>
                    <td *ngIf="clientDetail.sector == null"></td>
                  </tr>
                  <tr>
                    <th>GST Number:</th>
                    <td *ngIf="clientDetail.gstNumber!=null">
                      {{ clientDetail.gstNumber }}
                    </td>
                    <td *ngIf="clientDetail.gstNumber == null"></td>
                  </tr>
                  <tr>
                    <th>Principal Place Of Business:</th>
                    <td *ngIf="clientDetail.principalPlaceOfBusiness!=null">
                      {{ clientDetail.principalPlaceOfBusiness }}
                    </td>
                    <td *ngIf="clientDetail.principalPlaceOfBusiness==null"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>
  </div>
  